import { Flex, FormLabel, Text } from "@chakra-ui/react";
import { FC } from "react";

interface LabelComponentProps {
  title: string;
  fontSize?: string;
  isRequired?: boolean;
  helper?: string;
  isDisabled?: boolean;
  sx?: object;
  fontWeight?: string;
  fontColor?: string;
}

const LabelComponent: FC<LabelComponentProps> = ({
  title,
  fontSize = "sm",
  isRequired = false,
  helper,
  isDisabled = false,
  sx = {},
  fontWeight = "normal",
  fontColor,
}) => {
  return (
    <FormLabel sx={sx}>
      <Flex alignItems="center">
        <Text
          as="b"
          fontSize={fontSize}
          me={1}
          fontWeight={fontWeight}
          color={fontColor}
          whiteSpace="nowrap"
        >
          {title}
        </Text>
        {isRequired && (
          <Text fontSize={fontSize} fontWeight={fontWeight} color={fontColor}>
            (Obrigatório)
          </Text>
        )}
      </Flex>
      {helper && !isDisabled && (
        <Text fontSize="xs" fontWeight="normal">
          {helper}
        </Text>
      )}
    </FormLabel>
  );
};

export default LabelComponent;
